
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Baseservice } from './baseservice';
import { AuthenticationService } from './authentication.service';




@Injectable()
export class CompliancereturnsService extends Baseservice {
  protected url: string = environment.iCBMSWebApi.url;

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('document', http, authentication);
   }

  CreateComplianceLongTerm() {
    return this.http.get(`${this.url}/compliance/create/long/tearm`);
  }

  CreateComplianceNewly() {
    return this.http.get(`${this.url}/compliance/create/newly/created`);
   }


  getcarrierlist(id: number,) {
    return this.http.get(`${this.url}/compliance/getcarrierlist/${id}`);
  }

  getcarrierpermitlist(carrierid: number, calendarid: number) {
    return this.http.get(`${this.url}/compliance/getcarrierpermitlist/${carrierid}/${calendarid}`);
  }
  GetComplianceById(complianceid: any){
    //console.log(complianceid);
    return this.http.get(`${this.url}/compliance/GetComplianceById/${complianceid}`);
  }
  GetComplianceCertificatesById(permitId: any){
   // console.log(complianceid);
    return this.http.get(`${this.url}/compliance/GetComplianceCertificatesById/${permitId}`);
  }
  

  CreateNewCOmplianceRecord(permit_id: any) {   
    return this.http.get(`${this.url}/compliance/CreateComplianceRecord/${permit_id}`);
  }
  createComplianceCertificateTransaction(compID, compDetailsID) {
    return this.http.get(`${this.url}/compliance/createComplianceCertificateTransaction/${compID}/${compDetailsID}`);
  }
  updateComplianceCertificateTransaction(compID, compDetailsID) {
    return this.http.get(`${this.url}/compliance/updateComplianceCertificateTransaction/${compID}/${compDetailsID}`);
  }
  GetAllComplianceRecords(person_id: any) {
    return this.http.get(`${this.url}/compliance/GetAllComplianceByID/${person_id}`);
  }

  CreateAnnualComplianceRecords() {
    return this.http.get(`${this.url}/compliance/createAnnualComplianceRecords/created`);
   }

   CreateAnnualComplianceReminders() {
    return this.http.get(`${this.url}/compliance/createAnnualComplianceReminders/created`);
   }

   CreateAnnualComplianceInvoices() {
    return this.http.get(`${this.url}/compliance/createAnnualComplianceInvoices/created`);
   }

   CreateMonthlyComplianceRecords() {
    return this.http.get(`${this.url}/compliance/createMonthlyComplianceRecords/created`);
   }

   CreateMonthlyComplianceReminders() {
    return this.http.get(`${this.url}/compliance/MonthlyComplianceReminders/created`);
    
   }
  
}